var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$online)?_c('div',{staticClass:"wrapper"},[_vm._v("Проверьте подключение к интернету.")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }